import gql from "graphql-tag";

export const FullEntryScreenItemFragment = gql`
    fragment FullEntryScreenItem on EntryScreenItem {
        id
        stage
        linkUrl
        key
        title
        teaserImage(locales: [$lang, de]) {
            handle
            fileName
            width
            height
            url
            mimeType
        }

        entryScreenSubItems(orderBy: sortIndex_ASC) {
            id
            stage
            linkUrl

            title
        }
    }
`;

export default gql`
    query EntryScreen($lang: Locale!, $stage: Stage!) {
        entryScreenItems(orderBy: sortIndex_ASC, locales: [$lang], stage: $stage) {
            ...FullEntryScreenItem
        }
    }
    ${FullEntryScreenItemFragment}
`;



// WEBPACK FOOTER //
// ./src/queries/entryScreen.js